import { BRAND_PAYMENT_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[BRAND_PAYMENT_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		modalTitle: 'Choose payment method',
		// TODO schema: setBrandSettingsSchema,
	},
}
